export default "__VITE_ASSET__CeHBco7O__"